import { render, staticRenderFns } from "./TheExtraButtonEdit.vue?vue&type=template&id=075d2e15&scoped=true&"
import script from "./TheExtraButtonEdit.vue?vue&type=script&lang=ts&"
export * from "./TheExtraButtonEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TheExtraButtonEdit.vue?vue&type=style&index=0&id=075d2e15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d2e15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('075d2e15')) {
      api.createRecord('075d2e15', component.options)
    } else {
      api.reload('075d2e15', component.options)
    }
    module.hot.accept("./TheExtraButtonEdit.vue?vue&type=template&id=075d2e15&scoped=true&", function () {
      api.rerender('075d2e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheExtraButtonEdit.vue"
export default component.exports